import { LicenseManager, setupEnterpriseModules } from "ag-charts-enterprise";

let done = false;

/** Idempotent: financial + line charts need enterprise modules + shared license env. */
export function ensureAgChartsEnterprise(): void {
  if (done) return;
  done = true;
  const key =
    import.meta.env.VITE_AG_CHARTS_LICENSE_KEY?.trim() ||
    import.meta.env.VITE_AG_GRID_LICENSE_KEY?.trim() ||
    import.meta.env.VITE_AG_GRID_LICENSE?.trim() ||
    "";
  LicenseManager.setLicenseKey(key);
  setupEnterpriseModules();
}
